import { useEffect, useRef, useState } from 'react';

/**
 * Révélation au scroll (une seule fois). `active=false` → visible d'emblée,
 * zéro observer. Threshold bas + marge négative : l'animation part quand la
 * section entre franchement dans le viewport, pas au pixel près.
 */
export function useAppearOnScroll(active) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(!active);

  useEffect(() => {
    if (!active) return undefined;
    const el = ref.current;
    if (!el) {
      setVisible(true);
      return undefined;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' },
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [active]);

  return { ref, visible: active ? visible : true };
}
